import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { FileWarning, CheckCircle2 } from "lucide-react";

export function MissingDocsPanel({ companyId }) {
  const [m, setM] = useState(null);
  useEffect(() => { api.get(`/companies/${companyId}/missing`).then(r => setM(r.data)).catch(() => setM({ company: [], workers: [], total: 0 })); }, [companyId]);
  if (!m) return null;
  return (
    <div className={`border rounded-lg p-4 ${m.total ? "bg-amber-50 border-amber-200" : "bg-emerald-50 border-emerald-200"}`} data-testid="missing-panel">
      <div className="flex items-center gap-2 font-display font-semibold text-slate-900">
        {m.total ? <FileWarning size={18} className="text-amber-700" /> : <CheckCircle2 size={18} className="text-emerald-700" />}
        Documenti obbligatori mancanti: {m.total}
      </div>
      {m.company.length > 0 && (
        <div className="mt-2 text-sm"><span className="text-slate-500">Azienda:</span> {m.company.map(c => <Pill key={c}>{c}</Pill>)}</div>
      )}
      {m.workers.length > 0 && (
        <ul className="mt-2 space-y-1 text-sm">
          {m.workers.map(w => (
            <li key={w.worker_id}><Link to={`/lavoratori/${w.worker_id}`} className="text-blue-700 hover:underline font-medium">{w.worker}</Link>: {w.missing.map(c => <Pill key={c}>{c}</Pill>)}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function WorkerMissingPanel({ workerId, reloadKey }) {
  const [m, setM] = useState(null);
  useEffect(() => { api.get(`/workers/${workerId}/missing`).then(r => setM(r.data)).catch(() => null); }, [workerId, reloadKey]);
  if (!m) return null;
  return (
    <div className={`border rounded-lg p-4 ${m.missing.length ? "bg-amber-50 border-amber-200" : "bg-emerald-50 border-emerald-200"}`} data-testid="worker-missing-panel">
      <div className="flex items-center gap-2 font-display font-semibold text-slate-900 text-sm">
        {m.missing.length ? <FileWarning size={16} className="text-amber-700" /> : <CheckCircle2 size={16} className="text-emerald-700" />}
        {m.missing.length ? `${m.missing.length} documenti obbligatori mancanti` : "Tutti i documenti obbligatori presenti"}
      </div>
      {m.missing.length > 0 && <div className="mt-2">{m.missing.map(c => <Pill key={c}>{c}</Pill>)}</div>}
    </div>
  );
}

const Pill = ({ children }) => <span className="inline-block bg-white border border-amber-300 text-amber-900 rounded-full px-2 py-0.5 text-xs mr-1 mb-1">{children}</span>;
